// Generated by purs version 0.14.4
"use strict";
var Data_Argonaut_Decode_Error = require("../Data.Argonaut.Decode.Error/index.js");
var Data_Argonaut_Parser = require("../Data.Argonaut.Parser/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var parseJson = (function () {
    var $1 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(function (v) {
        return new Data_Argonaut_Decode_Error.TypeMismatch("JSON");
    });
    return function ($2) {
        return $1(Data_Argonaut_Parser.jsonParser($2));
    };
})();
module.exports = {
    parseJson: parseJson
};
